import type { CreateUserRequest, PromoteUserRequest, ResetPasswordResponse, UpdateUserRequest, UserAuditEventDto, UserDto } from '@ledokol/contracts'
import { api } from './client'

export interface UserListFilters {
  department_id?: string
  role?: string
  active?: boolean
  is_stub?: boolean
  search?: string
}

export async function fetchUsers(filters: UserListFilters = {}): Promise<UserDto[]> {
  const params: Record<string, string> = {}
  if (filters.department_id) params.department_id = filters.department_id
  if (filters.role) params.role = filters.role
  if (filters.active !== undefined) params.active = String(filters.active)
  if (filters.is_stub !== undefined) params.is_stub = String(filters.is_stub)
  if (filters.search) params.search = filters.search
  const r = await api.get<UserDto[]>('/users', { params })
  return r.data
}

export async function createUser(body: CreateUserRequest): Promise<UserDto> {
  const r = await api.post<UserDto>('/users', body)
  return r.data
}

export async function updateUser(id: string, body: UpdateUserRequest): Promise<UserDto> {
  const r = await api.patch<UserDto>(`/users/${id}`, body)
  return r.data
}

export async function promoteUser(id: string, body: PromoteUserRequest): Promise<UserDto> {
  const r = await api.post<UserDto>(`/users/${id}/promote`, body)
  return r.data
}

export async function deactivateUser(id: string): Promise<UserDto> {
  const r = await api.post<UserDto>(`/users/${id}/deactivate`)
  return r.data
}

/** Soft-delete сотрудника. Сотрудник пропадает из всех списков, FK сохраняются. */
export async function deleteUser(id: string): Promise<void> {
  await api.delete(`/users/${id}`)
}

export async function fetchUserAudit(id: string): Promise<UserAuditEventDto[]> {
  const r = await api.get<UserAuditEventDto[]>(`/users/${id}/audit`)
  return r.data
}

/** Админский сброс пароля. Временный пароль приходит ОДИН раз — не сохранять и не логировать. */
export async function resetUserPassword(id: string): Promise<string> {
  const r = await api.post<ResetPasswordResponse>(`/users/${id}/reset-password`)
  return r.data.temporary_password
}
